import { defaultIconProps, IconSvgWrapper, type IconProps } from "./base";

const CheckMarkCircleIcon = (props: IconProps) => {
  props = { ...defaultIconProps, ...props };

  return (
    <IconSvgWrapper {...props}>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_3795_9106)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0.81601 8.00041C0.81601 11.9604 4.04001 15.1844 8.00001 15.1844C11.96 15.1844 15.184 11.9604 15.184 8.00041C15.184 4.04041 11.96 0.816406 8.00001 0.816406C4.04001 0.816406 0.81601 4.04041 0.81601 8.00041ZM1.75201 8.00041C1.75201 4.55241 4.55201 1.75241 8.00001 1.75241C11.448 1.75241 14.248 4.55241 14.248 8.00041C14.248 11.4484 11.448 14.2484 8.00001 14.2484C4.55201 14.2484 1.75201 11.4484 1.75201 8.00041ZM4.93601 8.60041L6.67201 10.3364C6.84801 10.5124 7.14401 10.5124 7.34401 10.3364L11.232 6.44841C11.416 6.26441 11.416 5.96841 11.232 5.78441C11.048 5.60041 10.752 5.60041 10.568 5.78441L7.11201 9.24041C7.05601 9.29641 6.96001 9.29641 6.90401 9.24041L5.60001 7.93641C5.41601 7.75241 5.12001 7.75241 4.93601 7.93641C4.75201 8.12041 4.75201 8.41641 4.93601 8.60041Z"
            fill="#047957"
          />
        </g>
        <defs>
          <clipPath id="clip0_3795_9106">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </IconSvgWrapper>
  );
};

export default CheckMarkCircleIcon;
